










































































import { mapState } from "vuex";
import { gsap } from "gsap";

import IconBase from "@/common/components/atoms/IconBase.vue";

import IconArrowLeft3sticks from "@/common/components/icons/IconArrowLeft3sticks.vue";
import TheHeaderNaviOfUserMenu from "@/common/components/organisms/header/general/TheHeaderNaviOfUserMenu.vue";
import TheHeaderNaviOfSubMenu from "@/common/components/organisms/header/general/TheHeaderNaviOfSubMenu.vue";
import TheHeaderNaviOfCategoryMenu from "@/common/components/organisms/header/general/TheHeaderNaviOfCategoryMenu.vue";
import TheHeaderNaviOfOtherMenu from "@/common/components/organisms/header/general/TheHeaderNaviOfOtherMenu.vue";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";

@Component({
  name: "TheHeaderNaviOnGeneral",
  components: {
    IconBase,
    IconArrowLeft3sticks,
    TheHeaderNaviOfUserMenu,
    TheHeaderNaviOfSubMenu,
    TheHeaderNaviOfCategoryMenu,
    TheHeaderNaviOfOtherMenu
  }
})
export default class TheHeaderNaviOnGeneral extends Vue {
  @Prop({ type: Number, required: false, default: 0 })
  whatsNewUnreadCount!: number;
  @Prop({ type: Number, required: false, default: 0 })
  thanksPointUnreadCount!: number;
  @Prop({ type: Number, required: true })
  point!: number;

  pager = {
    hierarchy: 0,
    text: false,
    refsName: false,
    oldRefsName: false,
    key: false,
    oldKey: false
  };

  iconColor = "#3c3c3c";
  shown = false;

  get unit() {
    return commons.unit;
  }
  // get point() {
  //   return commons.point;
  // }

  dataOfPagerBeforeFormatting: any = {};

  animationChildItem(emitObj: any) {
    const { navi } = this.$refs;
    const { speed, width, shown } = emitObj;
    const prefix = shown === true ? "-=" : "+=";

    gsap.to(navi, speed, {
      x: `${prefix}${width}rem`
    });
  }

  setChildItemObject(paramsObj: any, shown = true) {
    this.dataOfPagerBeforeFormatting = {
      paramsObj,
      shown
    };
  }

  formatChildItemObject() {
    const { paramsObj, shown } = this.dataOfPagerBeforeFormatting;
    const { key, children, refsName, pagerObj } = paramsObj;
    const { hierarchy, text } = pagerObj;

    if (children === false) {
      return;
    }

    this.setPagerObject(
      {
        hierarchy,
        text,
        refsName,
        key
      },
      shown
    );
  }

  setPagerObject({ hierarchy, text, refsName, key }: any, shown: any) {
    const { pager } = this;
    let initHierarchy = hierarchy;

    if (hierarchy < 0) {
      initHierarchy = pager.hierarchy - 1;
    }

    if (initHierarchy < 0) {
      initHierarchy = 0;
    }

    const oldRefsName = pager.refsName;
    const oldKey = pager.key;

    this.pager = {
      hierarchy: initHierarchy,
      text,
      refsName,
      oldRefsName,
      key,
      oldKey
    };

    this.shown = shown;
  }

  @Watch("dataOfPagerBeforeFormatting")
  onDataOfPagerBeforeFormatting() {
    this.formatChildItemObject();
  }
}
